import script from "./AssetLifecycleCostsChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetLifecycleCostsChart.vue?vue&type=script&setup=true&lang=ts"

import "./AssetLifecycleCostsChart.vue?vue&type=style&index=0&id=e6bb3dae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6bb3dae"]])

export default __exports__